import { ISearchedUser, ISearchedParentUser } from 'apps/user/types/user'

export const transformUserSearchResponse = (
  user: ISearchedUser | ISearchedParentUser
): ISearchedUser => {
  const { cellPhone, email, id, name, phone, phoneExt, stateName, type } = user
  const [firstName, lastName] = name.split(' ')

  return {
    cellPhone,
    email,
    firstName,
    id,
    lastName,
    name,
    phone,
    phoneExt,
    type,
    stateName,
  }
}
